import {
  SpaceBetween,
  Box,
  TextContent,
  ColumnLayout,
  FormField,
  Select,
  Input,
} from "@cloudscape-design/components-themed";
import { isEqual } from "lodash";
import {
  ConfirmationMerchantInfoItem,
  ConfirmResult,
} from "../../../features/api-interfaces";
import { CONFIRMATION_RESULT, LABELS } from "../constants";
import { getConfirmationResultDict, getApiConfirmationResult } from "../util";

interface IRepresentativeConfirmation {
  merchant: ConfirmationMerchantInfoItem;
  updateItem: (merchant: ConfirmationMerchantInfoItem) => void;
  isMerchantRegistered: boolean;
  confirmResultList: ConfirmResult[];
}

/**
 * 要代表者確認
 */
const RepresentativeConfirmation = (props: IRepresentativeConfirmation) => {
  const { merchant, updateItem, isMerchantRegistered, confirmResultList } =
    props;
  const isRegistered = confirmResultList.find((item) =>
    isEqual(item.individualHandlingReason, merchant.individualHandlingReason)
  )?.confirmationResult;

  return (
    <SpaceBetween direction={"vertical"} size={"s"}>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.CONFIRMATION_RESULT}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Select
                selectedOption={getConfirmationResultDict(
                  merchant.confirmationResult
                )}
                options={CONFIRMATION_RESULT}
                filteringType={"none"}
                onChange={({ detail: { selectedOption } }) => {
                  updateItem({
                    ...merchant,
                    confirmationResult: getApiConfirmationResult(
                      selectedOption.value!
                    ),
                  });
                }}
                disabled={isMerchantRegistered || isRegistered}
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.REP_NAME}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_MIDDLE_LONG}>
              <Input value={String(merchant.repName ?? "")} readOnly />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.REP_NAME_KANA_APPLICATION}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_MIDDLE_LONG}>
              <Input
                value={String(merchant.repNameKanaApplication ?? "")}
                readOnly
              />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.REP_NAME_KANA_TSR}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_MIDDLE_LONG}>
              <Input value={String(merchant.repNameKanaTsr ?? "")} readOnly />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.COMPANY_URL}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_MIDDLE_LONG}>
              <Input value={String(merchant.companyUrl ?? "")} readOnly />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export default RepresentativeConfirmation;
